import { InjectionToken } from '@angular/core';
import { LngLatBoundsLike } from 'maplibre-gl';

export const API_URL = new InjectionToken<string>('ApiUrl');
export const APP_TITLE = new InjectionToken<string>('AppTitle');
export const DEFAULT_MAP_BOUNDS = new InjectionToken<LngLatBoundsLike>('DefaultMapBounds');
export const PARTNER_NAME = new InjectionToken<string>('PartnerName');
export const THEME_NAME = new InjectionToken<string>('ThemeName');
